export type ReasoningTagName = 'thinking' | 'scratchpad' | 'reasoning';

// Backreference `\1` is case-insensitive under `i` so `<Thinking>...</thinking>` pairs.
const REASONING_BLOCK_PATTERN = /<(thinking|scratchpad|reasoning)\b[^>]*>[\s\S]*?<\/\1\s*>/gi;

export interface StripReasoningTagsResult {
  text: string;
  removed: boolean;
  kinds: ReasoningTagName[];
  originalLength: number;
  strippedLength: number;
}

export function stripReasoningTags(input: string): StripReasoningTagsResult {
  const originalLength = input.length;

  if (input.indexOf('<') === -1) {
    return { text: input, removed: false, kinds: [], originalLength, strippedLength: originalLength };
  }

  const matchedKinds = new Set<ReasoningTagName>();
  const replaced = input.replace(REASONING_BLOCK_PATTERN, (_match, kind: string) => {
    matchedKinds.add(kind.toLowerCase() as ReasoningTagName);
    return '';
  });

  if (matchedKinds.size === 0) {
    return { text: input, removed: false, kinds: [], originalLength, strippedLength: originalLength };
  }

  const cleaned = replaced.replace(/\n{3,}/g, '\n\n').trim();

  return {
    text: cleaned,
    removed: true,
    kinds: Array.from(matchedKinds),
    originalLength,
    strippedLength: cleaned.length,
  };
}
